import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';
import contentConfig from '@/modules/content/config';
import { ContentEntity, ResourceTypeEnum } from '@/types/schema';

import { renderSurveyContentImage } from '../../renderers';
import { SurveyModalHeaderProps } from './types';

const { label } = contentConfig[ResourceTypeEnum.Survey];

function SurveyModalHeader(props: SurveyModalHeaderProps) {
  const { t } = useTranslation();
  const { isMobile } = useScreen();
  const { survey } = props;

  return (
    <Stack
      alignItems="center"
      className="native:pt-10 sticky top-0 z-10 border-b border-border bg-bg-primary p-18 pb-16 xs:rounded-t-8 xs:p-20 xs:pb-20">
      {renderSurveyContentImage({
        survey: survey as ContentEntity,
        className: cn(
          'flex-shrink-0 me-12 xs:me-16',
          isMobile ? 'rounded-4' : 'rounded-full h-36 w-36',
        ),
        width: isMobile ? 48 : 36,
        height: isMobile ? 48 : 36,
      })}
      <Stack direction="col">
        <Typography
          className="flex-1"
          color="text-text-primary"
          numberOfLines={2}
          variant={isMobile ? 'heading-s' : 'body-short-02'}>
          {survey.name}
        </Typography>
        <Typography
          color="text-text-secondary"
          variant={isMobile ? 'body-short-02' : 'body-short-03'}>
          {t(label.title)}
        </Typography>
      </Stack>
    </Stack>
  );
}

export default SurveyModalHeader;
